export const getConversationIdFromRoute = route => {
  const conversationId =
    route.params.conversation_id || route.params.conversationId;
  return conversationId ? Number(conversationId) : null;
};

export const isConversationRoute = route =>
  Boolean(getConversationIdFromRoute(route));
